<template>
    <div v-if="showMark" class="screen-warp" @click.stop="toClose">
        <div :class="['screen-panel',{'screen-show':showPanel}]" @click.stop="()=>{}">
            <div class="search-input">
                <span class="label">小区名称</span>
                <input type="text" placeholder="请输入小区名称" v-model="searchInfo.plotName"/>
            </div>
            <template v-for="(item,index) in arrSearchConfig">
                <div class="search-item">
                    <span class="label">{{ item.name }}</span>
                    <div class="option-panel">
                        <template v-for="(option,option_i) in item.tabList">
                            <div :class="['option',{'option-act':option.active}]" @click="toOptionItem(index,option_i)">
                                {{ option.name }}
                            </div>
                        </template>
                    </div>
                </div>
            </template>
            <div class="btn-panel">
                <div class="btn" @click="clearChecked"> 清空记录</div>
                <div class="btn btn-light" @click="confirm"> 确定</div>
            </div>
        </div>
    </div>
</template>

<script>

import {getPlanSearchConfig} from "@/js/project/v3/index.js";

export default {
    name: "screenPopup",
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showMark: false,
            showPanel: false,
            arrSearchConfig: [
                {
                    multiple: false,
                    checked: [],
                    type: "antType",
                    name: "系统类型",
                    tabList: [],
                },
                {
                    multiple: true,
                    checked: [],
                    type: "house_area",
                    name: "房屋面积",
                    tabList: [],
                },
                {
                    multiple: true,
                    checked: [],
                    type: "house_cate",
                    name: "房屋种类",
                    tabList: [],
                },
                {
                    multiple: true,
                    checked: [],
                    type: "plan",
                    name: "案例进度",
                    tabList: [],
                },
                {
                    multiple: true,
                    checked: [],
                    type: "praise",
                    name: "案例类型",
                    tabList: [],
                },
                /*{
                    multiple: true,
                    checked: [],
                    type: "decorate",
                    name: "装修",
                    tabList: [],
                },*/
            ], // 搜索条件配置

            searchInfo: {
                plotName: "",
                houseArea: "",
                // houseType: "",
                houseCate: "",
                typeId: "",
                plan: "",
                praise: "",
                // decorate: "",
            },//搜索的参数-项目案例
        }
    },
    watch: {
        show(newValue) {
            if (newValue) {
                this.showMark = true;
                setTimeout(() => {
                    this.showPanel = true;
                }, 10)
            } else {
                this.showPanel = false;
                setTimeout(() => {
                    this.showMark = false;
                }, 200)
            }
        }
    },
    mounted() {
        getPlanSearchConfig().then(res => {
            const data = res.data.data.result;
            this.arrSearchConfig.forEach((item) => {
                for (const key in data) {
                    if (key === item.type) {
                        item.tabList = data[key];
                    }
                }
            });
        })
    },
    methods: {
        toClose() {
            this.$parent.isShowCondition = false;
        },
        toOptionItem(i1, i2) {
            let code = this.arrSearchConfig[i1].tabList[i2].code;

            if (code == '后装新风') {
                this.$toast({
                    message: "该功能暂未开放",
                    duration: 1200,
                });
                return
            }

            const active = this.arrSearchConfig[i1].checked.findIndex(
                (item) => item === code
            );
            if (active >= 0) {
                // this.arrSearchConfig[i1].tabList[i2].active = false;
                this.$set(this.arrSearchConfig[i1].tabList[i2], 'active', false)
                this.arrSearchConfig[i1].checked.splice(active, 1);
            } else {
                // this.arrSearchConfig[i1].tabList[i2].active = true;
                if (this.arrSearchConfig[i1].multiple) {
                    // 多选
                    this.$set(this.arrSearchConfig[i1].tabList[i2], 'active', true)
                    this.arrSearchConfig[i1].checked.push(code);
                } else {
                    // 单选
                    this.arrSearchConfig[i1].tabList.forEach((it,i) => {
                        if(i2 === i){
                            this.$set(this.arrSearchConfig[i1].tabList[i], 'active', true)
                        }else{
                            this.$set(this.arrSearchConfig[i1].tabList[i], 'active', false)
                        }
                    })
                    this.arrSearchConfig[i1].checked = [code];
                }
            }
        },

        // 清空记录
        clearChecked() {
            this.arrSearchConfig.forEach((item) => {
                item.checked = [];
                item.tabList.forEach((it) => {
                    it.active = false;
                })
            });
            this.searchInfo = {
                plotName: "",
                houseArea: "",
                // houseType: "",
                houseCate: "",
                typeId: "",
                plan: "",
                praise: "",
                // decorate: "",
            };
            this.$emit('onCondition', this.searchInfo);
        },
        confirm() {
            const createStr = (arr) => {
                if (arr.length === 0) {
                    return "";
                }
                let str = arr.reduce((prev, curr) => {
                    return `${curr},${prev}`;
                }, "");
                return str.substring(0, str.lastIndexOf(","));
            };
            this.arrSearchConfig.forEach((item) => {
                switch (item.type) {
                    case "house_area":
                        this.searchInfo.houseArea = createStr(item.checked);
                        break;
                    /*case "house_type":
                        this.searchInfo.houseType = createStr(item.checked);
                        break;*/
                    case "house_cate":
                        this.searchInfo.houseCate = createStr(item.checked);
                        break;
                    case "antType":
                        this.searchInfo.typeId = createStr(item.checked);
                        break;
                    case "plan":
                        this.searchInfo.plan = createStr(item.checked);
                        break;
                    case "praise":
                        this.searchInfo.praise = createStr(item.checked);
                        break;
                    /*case "decorate":
                        this.searchInfo.decorate = createStr(item.checked);
                        break;*/
                }
            });
            this.$emit('onCondition', this.searchInfo);
        },
    }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>

